const videos = [
  {
    title: '台北娜娜最新动态独家解析',
    desc: '深度拆解台北娜娜本周最新发布内容背后的故事',
    views: '128万',
    duration: '15:42',
    image: 'https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20image%20of%20video%20content%20and%20media%20player%20concept%2C%20coral%20and%20gold%20accent%20colors%2C%20abstract%20play%20button%20and%20film%20strip%20elements%20on%20soft%20neutral%20background%2C%20modern%20digital%20media%20aesthetic%2C%20high%20quality&width=700&height=440&seq=media-01&orientation=landscape',
  },
  {
    title: '莫里秀全集大汇总，一口气看完',
    desc: '莫里秀所有已发布内容的完整整理，一次看过瘾',
    views: '96万',
    duration: '28:15',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20style%20photography%20of%20video%20collection%20and%20playlist%20concept%2C%20warm%20amber%20and%20terracotta%20palette%2C%20abstract%20thumbnail%20grid%20and%20media%20icons%20on%20clean%20light%20background%2C%20organized%20content%20library%20aesthetic&width=700&height=440&seq=media-02&orientation=landscape',
  },
  {
    title: '玩偶姐姐身份之谜：线索大揭秘',
    desc: '收集所有关于玩偶姐姐的已知线索，逐一分析解读',
    views: '215万',
    duration: '22:08',
    image: 'https://readdy.ai/api/search-image?query=Sophisticated%20editorial%20concept%20of%20investigation%20and%20clue%20analysis%20theme%2C%20warm%20coral%20and%20gold%20gradients%2C%20abstract%20evidence%20and%20detective%20elements%20on%20soft%20cream%20background%2C%20mysterious%20and%20professional%20mood&width=700&height=440&seq=media-03&orientation=landscape',
  },
  {
    title: '吃瓜圈年度十大名场面回顾',
    desc: '那些让全网沸腾的经典吃瓜时刻，每一个都值得重温',
    views: '187万',
    duration: '18:55',
    image: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20photography%20of%20highlight%20reel%20and%20best%20moments%20concept%2C%20golden%20and%20terracotta%20tones%2C%20abstract%20trophy%20and%20spotlight%20elements%20on%20soft%20neutral%20background%2C%20celebratory%20and%20exciting%20mood&width=700&height=440&seq=media-04&orientation=landscape',
  },
  {
    title: '台北娜娜vs莫里秀：终极对比',
    desc: '两大热门人物全方位对比分析，谁才是吃瓜圈顶流？',
    views: '302万',
    duration: '25:30',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20style%20image%20of%20versus%20and%20comparison%20concept%2C%20warm%20coral%20and%20amber%20color%20scheme%2C%20abstract%20split%20screen%20and%20balance%20elements%20on%20clean%20light%20background%2C%20dynamic%20and%20engaging%20aesthetic&width=700&height=440&seq=media-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精彩视频
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            高清视频合集，热门人物精彩内容一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {videos.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl overflow-hidden cursor-pointer group transition-all duration-300 hover:bg-background-200/70"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-foreground-900/20 group-hover:bg-foreground-900/10 transition-colors" />
                <span className="absolute bottom-3 right-3 px-2 py-0.5 text-[11px] font-medium rounded bg-foreground-900/70 text-white">
                  {item.duration}
                </span>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <i className="ri-play-fill text-2xl"></i>
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1.5 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {item.desc}
                </p>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-eye-line"></i>
                  </span>
                  {item.views} 次观看
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}